// Locale strings of report 2.4 (equity-changes), accountant's document 2026-10-03.
// Merged ONCE into finance.reports2.<camelCaseSlug> by ./index.js: use
// $t("finance.reports2.<camelCaseSlug>.<key>"). Owned by this report only.
export default {
  pageTitle: "Statement of Changes in Equity",
  title: "Statement of Changes in Equity",
  statement: "Description",
  total: "Total",
  unposted: "Not closed",
  unpostedHint: "Income-statement result not yet closed into equity (computed)",
  unpostedSummary: "Unclosed result",
  check: "Check: closing - (opening + movements)",
  difference: "Difference",
  entriesCount: "Entries",
  entry: "Entry",
  memo: "Description",
  showEntries: "Show entries",
  hideEntries: "Hide entries",
  outsideTitle: "Equity accounts outside the statement columns",
  opening: "Opening balance",
  movement: "Movement",
  closing: "Closing balance",
  warnings: "Warnings",
  notes: "Notes",
  sheetName: "Equity",
  outsideSheet: "Outside columns",
  sectionTitle: "Currency",
  columns: {
    capital: "Capital",
    legal_reserve: "Legal reserve",
    optional_reserve: "Optional reserve",
    other_reserves: "Other reserves",
    expansion_reserve: "Expansion reserve",
    current_year_profit: "Current-year profit",
    retained_earnings: "Retained earnings",
  },
  rows: {
    opening: "Opening balance",
    net_profit: "Net profit for the year",
    profit_transfer: "Transfer of the year's profit",
    legal_reserve_formation: "Legal reserve formation",
    optional_reserve_formation: "Optional reserve formation",
    emergency_reserve_formation: "Emergency reserve formation",
    expansion_reserve_formation: "Expansion reserve formation",
    dividends_declared: "Dividends declared",
    prior_year_revenues: "Prior-year revenues",
    prior_year_expenses: "Prior-year expenses",
    prior_profit_transfer: "Transfer of prior profits (comparison)",
    capital_change: "Capital increase / decrease",
    other_movements: "Other movements",
    closing: "Closing balance",
  },
};
